import Header from "@/components/Header"
import OAuthCallback from '@/components/OauthCallback'
import { ProtectedRoute, PublicOnlyRoute } from '@/components/ProtectedRoute'
import ScrollToTop from "@/components/ScrollToTop"
import { Toaster } from "@/components/ui/toaster"
import AccountSettingsPage from "@/pages/AccountSettingsPage"
import CreateBookPage from "@/pages/CreateBookPage"
import ForgotPasswordPage from "@/pages/ForgotPasswordPage"
import HomePage from "@/pages/HomePage"
import LandingPage from "@/pages/LandingPage"
import LibraryPage from "@/pages/LibraryPage"
import PasswordResetPage from "@/pages/PasswordResetPage"
import PricingPage from '@/pages/PlansPage'
import ReadStoryPage from "@/pages/ReadStoryPage"
import SignInPage from "@/pages/SigninPage"
import SignupPage from '@/pages/SignupPage'
import VerifyEmailPage from "@/pages/VerifyEmailPage"
import { ThemeProvider } from '@/providers/ThemeProvider'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { NotFoundPage, UnauthorizedPage } from "./pages/ErrorPages"
import SubscriptionComplete from "./pages/SubscriptionComplete"
import ExampleStoriesPage from "./pages/ExampleStoriesPage"

function App() {
    return (
        <ThemeProvider>
            <Router>
                <ScrollToTop />
                <div className="min-h-screen grid grid-rows-[auto_1fr]">
                    <Header />
                    <Routes>
                        {/* Public routes */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/home" element={<HomePage />} />
                        <Route path="/plans" element={<PricingPage />} />
                        <Route path="/story/:storyId" element={ <ReadStoryPage /> }/>
                        <Route path="/examples" element={ <ExampleStoriesPage /> }/>
                        <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
                        <Route path="/unauthorized" element={<UnauthorizedPage />} />
                        <Route path="*" element={<NotFoundPage />} />

                        {/* Authentication routes - only accessible when logged out */}
                        <Route
                            path="/signup"
                            element={
                                <PublicOnlyRoute>
                                    <SignupPage />
                                </PublicOnlyRoute>
                            }
                        />
                        <Route
                            path="/signin"
                            element={
                                <PublicOnlyRoute>
                                    <SignInPage />
                                </PublicOnlyRoute>
                            }
                        />
                        <Route
                            path="/forgot-password"
                            element={
                                <PublicOnlyRoute>
                                    <ForgotPasswordPage />
                                </PublicOnlyRoute>
                            }
                        />
                        <Route
                            path="/password/reset"
                            element={
                                <PublicOnlyRoute>
                                    <PasswordResetPage />
                                </PublicOnlyRoute>
                            }
                        />

                        <Route
                            path="/account/social/google"
                            element={
                                <PublicOnlyRoute>
                                    <OAuthCallback />
                                </PublicOnlyRoute>
                            }
                        />

                        {/* Protected routes - only accessible when logged in */}
                        <Route
                            path="/settings"
                            element={
                                <ProtectedRoute>
                                    <AccountSettingsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/create"
                            element={
                                <ProtectedRoute>
                                    <CreateBookPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/library"
                            element={
                                <ProtectedRoute>
                                    <LibraryPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/subscriptioncomplete"
                            element={
                                <ProtectedRoute>
                                    <SubscriptionComplete />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <Toaster />
                </div>
            </Router>
        </ThemeProvider>
    )
}

export default App
